import { gql } from '../utils/general';

export const getEmailSubscriptions = gql`
  query emailSubscriptions($topicIds: [String!]!, $topicType: String!) {
    emailSubscriptions(topicIds: $topicIds, topicType: $topicType) {
      items {
        emails {
          email
          userId
        }
        topicId
        entityId
        topicType
      }
      metadata {
        totalCount
      }
    }
  }
`;
export const getComments = gql`
  query comments(
    $entityId: String!
    $limit: Int
    $offset: Int
    $topicId: String!
    $topicType: String!
    $parentId: String,
    $orderBy: String
  ) {
    comments(
      entityId: $entityId
      limit: $limit
      offset: $offset
      topicId: $topicId
      topicType: $topicType
      parentId: $parentId,
      orderBy: $orderBy
    ) {
      comments {
        id
        createdAt
        updatedAt
        text
        createdBy
        entityId
        topicId
        topicType
        ip
        parentId
        createdByUser {
          id
          name
          type
        }
        replyCount
      }
      errors{
      code
      message
      }
      success
      totalCount
    }
  }
`;

export const addComment = gql`
mutation PostComment(
  $email: String
  $entityId: String!
  $name: String
  $parentId: String
  $text: String!
  $topicId: String!
  $topicType: String!
  $userType: String!
  $authUserId: String
) {
  postComment(
    email: $email
    entityId: $entityId
    name: $name
    parentId: $parentId
    text: $text
    topicId: $topicId
    topicType: $topicType
    userType: $userType
    authUserId: $authUserId
  ) {
    success
    errors { code message }
    commentId
    createdAt
    text
    entityId
    topicId
    topicType
    userId
  }
}
`